<template>
  <el-dialog :visible.sync="dialogVisible" :title="$t('components.tips')" width="410px" class="diglog-card" @close="$emit('closeModal')">
    <div class="content">
      <div><i class="icon-submit" /><span class="submit-text">{{ $t('data.successfully_submit') }}</span></div>
      <p class="amount-text">{{ $t('data.top_up_amount') }}：<span style="color:#488CE8">{{ $store.getters.currency }}  {{ amount | numWithDot }}</span></p>
      <div class="line" />
      <p class="tip">{{ $t('data.recharge_success_tip') }}</p>
      <div slot="footer" class="dialog-footer" style="width: 100%">
        <el-button type="info" class="btn-back" @click="dialogVisible = false">{{ $t('components.close') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Recharge_Success_Modal',
  components: {
  },
  data() {
    return {
      amount: 0,
      dialogVisible: false
    }
  },
  methods: {
    changModalStatus(value, data) {
      this.dialogVisible = value
      this.amount = data
    }
  }
}
</script>


<style scoped lang="scss">
p{
  margin: 0;
}
.content{
  display: flex;
  flex-direction: column;
  align-items: center;

}
.icon-submit{
  height: 24px;
  width: 24px ;
  display: inline-block;
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAYAAACoYAD2AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANNSURBVHgB1ZjdThNBFIDPmdZqjCYloAlXtk8APIHlCYALFa5snwC4LDcsMdJbeALwqooX4hMITwA+AfXKBCSswaBN6xzPTLt0W3Y7s+1uwS8hw7Yz2y/zd84MwH8AwhA436u5+5nUHBBMA1CO35bzviMCl1/ukqSvIPAIU/KwPLZUgwGILOlc7GQz8tEykizwYyFKWwI45mIrqrC1ZEeOVvjnsjAMBDUSYndt/MWGTXUryTdn1UIaxI5/OGOBZQFkqfxk6aBfNQEGNs8/rqdRfIldUKHeye9Wv9G/Wh8q53s7vAKKMBJwtzzxshT4TViT0Qp6BIsGDrfu/pELKqgYNPQ3erJyWi2C4EVym5Cc9S+mLsnKRTUHzYQWSRR41dfTVzPOWMlVj93DLcXyrQsq2OFe88FK57GN7sW/4gTuDOTWU7/zqjeve1I2oQh3Csx6vXktKUC8hhFARNtqYejSgEBcVqUebh32VFRJGpIbvGod77Hy48MnLuYNbWZ1T6YIpyFpegT1R0TfjM3YTUuiwOeQJAGCaqEi4JypKSIUvDmZg6QIEbTejwVOtSXRXNkDqWZdd1hB/Q7KtiUtkliV+zVkvjy+mFdlKxdMWFCDWWM+6SGBPpcnWym/LptyNlQ0NsEW3nC7xoqIz/zPoaIxC3YkkYySzHxvGnVDNAFB5rglSfoUZ4RPiE6YKB9dVxMQVHKujjibZ++3sB2CrJqhcEwnvbjSPsnhs7WZA+1HaRjUo0kIKgS7acl6+sGxzeIBC9FYE2ee6ypD15LO2IJLJN9BRHpFY8/skQ504T2/Pd2bFoKOYCBwl6T8iUKle0PebvhRwYMXZvcZxyZ1GhnEx9tFfbztjjgNuRp1biZGg653jy5J1bU8bFaXSImigsJk59Yt8Abjlod9vzzxasH/QWCCUU9l1FywikKxos7bl1d21yxqS+L5uWBMx+JE/RaHVydfurEmQlM1NSfq6cwM/xspGg0GHdR/Xc3456Efq0vUylnV4YPQOsQOumqhrj1d3OpbCyyp8CU+pMABEdf5nKNJg0phvecn8sX+cLJqD2Y5ktumK+iuVjAgzglf9D9+WEAp51l4qnWY6w2JWqrGf7xT0GH98s9+0MIw8Q8TAblhAGjshQAAAABJRU5ErkJggg==');
  background-size: 100% 100%;
}
.submit-text{
  vertical-align: bottom;
  display: inline-block;
  margin-left: 12px;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #196532;
}
.amount-text{
  margin-top: 32px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #000000;
}
.line{
  width: 294px ;
  height: 1px;
  margin: 16px auto;
  background: #B5BCC9;
}
.tip{
  padding: 0 26px;
  font-size: 12px;
  color: #7A869E;
  text-align: center;
}

.btn-back{
  width: 100%;
  margin-top: 48px;
  font-weight: 600;
  font-size: 14px;
}
</style>
